export const colors = {
  base: "#F6F6F6",
  primary: "#FFFFFF",
  accent: "#245F73",
  secondary: "#BBBDBC",
  tealOption: "#81D8D0",
  yellowOption: "#D7D982",
  redOption: "#D99382",
};

export const tooltipVariants = {
  hidden: { opacity: 0, y: 6 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.18 } },
};